<template>
  <page-header :title="title" icon="bi-person-lines-fill" :back="true"/>
  <f-loader ref="loader">

    <f-form ref="form" :no-delete="true" :no-edit="noEdit" @form-send="onFormSend">
      <template v-slot:default="form">
        <f-input v-model="item.login" label="Логин/SID" w="12" :disabled="true"/>
        <f-input v-model="item.name" label="Фамилия Имя" w="6" :disabled="!form.edit"/>
        <f-input v-model="item.email" label="Email" w="6" :disabled="!form.edit"/>

        <div v-if="form.edit" class="col-12">
          <small>Оставьте поля пустыми или введите данные, чтобы поменять пароль. </small>
        </div>
        <f-input v-if="form.edit" v-model="password1" type="password" label="Пароль" w="6" :disabled="!form.edit"/>
        <f-input v-if="form.edit" v-model="password2" type="password" label="Пароль повторно" w="6" :disabled="!form.edit"/>
      </template>
    </f-form>
  </f-loader>
</template>

<script>
import {http} from "@/misc/http";
import FInput from "@/components/FInput";
import PageHeader from "@/components/PageHeader";
import FForm from "@/components/FForm";
import FLoader from "@/components/FLoader";
import {config} from "@/state/config";

export default {
  components: {FForm, PageHeader, FInput, FLoader},
  data() {
    return {
      item: {
        login: "",
        name: "",
        email: "",
      },
      password1: "",
      password2: "",
    }
  },

  async mounted() {
    await this.$refs.loader.wrap(async () => {
      this.item = await http.get('/profile');
    });
  },

  methods: {
    async onFormSend() {
      await this.$refs.loader.wrap(async () => {
        if ((this.password1 || this.password2) && this.password1 != this.password2) throw Error("Пароли не совпадают.");
        this.item.password = this.password1 || null;
        this.item = await http.post("/profile", this.item);
        this.password1 = "";
        this.password2 = "";
        this.$refs.form.accept();
      });
    },
  },

  computed: {
    title() {
      return "Профиль \"" + this.item.login + "\"";
    },

    noEdit(){
      return !!config.keycloak;
    },

  },


}
</script>

